import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CarFront } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/fleet-portal')({
    staticData: {
        modules: ['fleet'],
        permissions: ['fleet_portal:access'],
        ui: {
            title: 'Fleet portal',
            icon: CarFront,
        },
        breadcrumb: {
            title: 'Fleet portal',
        },
    },
    component: Outlet,
});
